import { KEYCODES } from './util/keycodes';

function updateSearchResults(target) {
  const queryString = target.val().trim();
  const results = $.stores.search.results[queryString];
  const html = results && results.html ? results.html.trim() : '';
  const $search = $('[data-search]');
  const $searchResults = $('[data-instant-search-results]');

  $search[html ? 'addClass' : 'removeClass']('active');
  $searchResults.html(html)[html ? 'show' : 'hide']();
  $.stores.initElement($searchResults.first(), null, true);
  if (results && results.action) {
    $search.attr('action', results.action);
  }
}

$(document).on('click', '[data-instant-search-suggest]', (e) => {
  e.preventDefault();
  e.stopPropagation();
  $('[data-instant-search]').val($(e.target).text()).trigger('input').focus();
});

$(document).on('input', '[data-instant-search]', window.Foundation.util.debounce((e) => {
  const queryString = $(e.target).val().trim();
  const target = $(e.target);
  if (queryString || target.is('[data-instant-search-empty]')) {
    $.stores.search.search(target.attr('data-instant-search'), queryString).then(() => {
      updateSearchResults(target);
    });
  } else {
    updateSearchResults(target);
  }
}, 350));

$(document).on('mouseenter', '[data-instant-search-item]', function() {
  $(this).addClass('hover');
});

$(document).on('mouseleave', '[data-instant-search-item]', function() {
  $(this).removeClass('hover');
});

$(document).on('mousemove', () => {
  $('[data-instant-search-item].active').removeClass('active');
});

$(document).on('keydown', '[data-instant-search]', function(event) {
  const current = $('[data-instant-search-item].active, [data-instant-search-item].hover');
  if (event.which === KEYCODES.DOWN) {
    event.preventDefault();
    $('[data-instant-search-item].hover').removeClass('hover');
    if (current.length) {
      const next = current.nextAll('[data-instant-search-item]:first');
      if (next.length) {
        next.addClass('active')[0].scrollIntoView({
          behavior: 'instant',
          block: 'nearest',
          inline: 'nearest',
        });
        current.removeClass('active');
      }
    } else {
      $('[data-instant-search-results] [data-instant-search-item]:first').addClass('active');
    }
  } else if (event.which === KEYCODES.UP) {
    event.preventDefault();
    $('[data-instant-search-item].hover').removeClass('hover');
    if (current.length) {
      const prev = current.prevAll('[data-instant-search-item]:first');
      if (prev.length) {
        prev.addClass('active')[0].scrollIntoView({
          behavior: 'instant',
          block: 'nearest',
          inline: 'nearest',
        });
      }
      current.removeClass('active');
    } else {
      $('[data-instant-search-results] [data-instant-search-item]:last').addClass('active');
    }
  } else if (event.which === KEYCODES.ENTER) {
    const active = $('[data-instant-search-item].active a');
    if (active.length) {
      document.location.href = active.attr('href');
      event.preventDefault();
    }
  } else if (event.which === KEYCODES.ESCAPE) {
    $(this).val('').trigger('input');
  }
});

$(document).on('focus', '[data-instant-search]', function() {
  // trigger search and show results if a search term is given
  $(this).trigger('input');
});

$(document).on('click', (event) => {
  // hide results
  const target = $(event.target);
  if (!target.closest('[data-instant-search-results]').length && !target.is('[data-instant-search]')) {
    $('[data-search]').removeClass('active');
    $('[data-instant-search-results]').hide();
  }
});

$(document)
  .on('click', '[data-mobile-search-toggle]', () => {
    $('[data-mobile-search-toggle]').hide();
    $('[data-mobile-search]').show();
    $('[data-mobile-search-input]').focus();
  });

$(document)
  .on('click', (event) => {
    const target = $(event.target);
    if (!target.closest('[data-mobile-search], [data-mobile-search-toggle]').length) {
      if ($('[data-mobile-search-toggle]').length) {
        $('[data-mobile-search-toggle]').show();
        $('[data-mobile-search]').hide();
      }
    }
  });
